module.exports = __webpack_public_path__ + "static/media/07.6b3de975.mp3";